import React from 'react';
import Text from './Typography';

type Props = {
  name: string,
  type: string
}

/* eslint-disable */
// eslint doesn't like bitwise operators

const hashCode = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}

/* Aug 2018 - the colors are randomized using the name of the intuition
 * As this is how it is done on mobile. Can easily be changed to select by type, as well.
 */

const CategoryIcon = ({className, name, type}: Props) => {
  let initials = name ? name.match(/\b\w/g) || [] : [];
  initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();

  const categoryColors = ['#1F547B', '#672BC2', '#9F69F0', '#69F0F0', '#F6BE2F', '#EF1EA4'];

  let index = 0;
  if (name) {
    index = Math.abs(hashCode(name) % (categoryColors.length -1));
  } else {
    index = Math.abs(hashCode(type) % (categoryColors.length -1));
  }
  
  const color = categoryColors[index];
  return (
    <Text span
      style={{ backgroundColor: color }}
      className={`category-icon is-${color} ${className}`}
      >
      {initials}
    </Text>
  );
};

export default CategoryIcon;



// WEBPACK FOOTER //
// ./src/components/shared/CategoryIcon.js